import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4778054f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4778054f')) {
      api.createRecord('4778054f', component.options)
    } else {
      api.reload('4778054f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4778054f&", function () {
      api.rerender('4778054f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/charts/vacations/components/remove-vacation-modal/index.vue"
export default component.exports